import { FC, useState, useCallback, useMemo } from 'react'
import styles from 'components/features/socialFeed/CommentCompose/CommentCompose.styl'
import { WithComposeId, WithPostUid } from 'interfaces/feed'
import { Compose } from 'components/features/socialFeed/Compose/Compose'
import { ComposeLayout } from 'components/features/socialFeed/ComposeLayout/ComposeLayout'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { createComposeHasContentSelector } from 'selectors/feedComposeSelectors'
import { SocialProfileEnsure } from 'components/features/socialFeed/SocialProfileEnsure/SocialProfileEnsure'
import { useComposeState } from 'helpers/hookHelpers'

type CommentComposeProps =
  & WithComposeId
  & WithPostUid
  & {
    placeholder?: string
  }

export const CommentCompose: FC<CommentComposeProps> = (props) => {
  const {
    composeId,
    placeholder,
    postUid,
  } = props

  const composeHasContentSelector = useMemo(createComposeHasContentSelector, [])
  const hasContent = useStoreSelector((state) => composeHasContentSelector(state, props))

  const [counter, setCounter] = useState(+hasContent)
  const handleClick = useCallback(() => {
    setCounter(counter + 1)
  }, [counter, setCounter])

  const { id } = useComposeState(props.composeId, { id: null })
  const isComposeStateExists = !!id

  return (
    <SocialProfileEnsure composeId={ composeId }>
      { !isComposeStateExists && (
        <div onClick={ handleClick }>
          <ComposeLayout composeId={ composeId }>
            <div className={ styles.commentCompose }>
              { placeholder }
            </div>
          </ComposeLayout>
        </div>
      )}
      { counter !== 0 && (
        <Compose
          key={ counter }
          composeId={ composeId }
          placeholder={ placeholder }
          postUid={ postUid }
          focusOnMount
        />
      )}
    </SocialProfileEnsure>
  )
}
